module.exports = __webpack_public_path__ + "img/food_smile.99755e2b.png";